/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_TitleInputs */



/**
* | output |
* | --- |
* | "Team Manager" |
*
* @param {Team_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_title = /** @type {((inputs?: Team_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestion d’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teamleiter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Responsabile della squadra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер команды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gerente de equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("团队经理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームマネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दल प्रभंधक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerente de Equipe")
	return /** @type {LocalizedString} */ ("Team Manager")
});